export const LOADING_PAGE_ABOUT = 'LOADING_PAGE_ABOUT';
